/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Payment_Proof_Too_LargeInputs */

const vi_tea_purchase_payment_proof_too_large = /** @type {(inputs: Tea_Purchase_Payment_Proof_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh vượt quá 10MB`)
};

/**

* @param {Tea_Purchase_Payment_Proof_Too_LargeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_payment_proof_too_large = /** @type {((inputs?: Tea_Purchase_Payment_Proof_Too_LargeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Payment_Proof_Too_LargeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_payment_proof_too_large(inputs)
});